<template>
    <div>
        <h1>欢迎使用山东星驰泰和拍卖系统</h1>
        <h1>如在使用中遇到任何问题,请联系</h1>
        <!-- <svg-icon icon-class="button" class-name="icon" style="height: 250px;width: 160px;"/> -->
        <!-- <svg-icon icon-class="404" class-name="icon" style="height: 250px;width: 160px;"/> -->
        <!-- <vueMiniPlayer ref="vueMiniPlayer" :video="video" :mutex="true" @fullscreen="handleFullscreen" /> -->
    </div>   
</template>

  <script>
    export default {
      data () {
        return {
          video: {
              url: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
              cover: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png',
              muted: false,
              loop: false,
              preload: 'auto',
              poster: '',
              volume: 1,
              autoplay: false
          }
        }
      },
      methods:{
        handleFullscreen(){
  
        }
      }
    }
  </script>